<span mat-dialog-title>Passwort zurücksetzen</span>
<mat-dialog-content>
  <p>Geben Sie die E-Mail Adresse Ihres Kontos an. Eine E-Mail mit dem neuen Passwort wird an Sie
    gesendet.</p>
  <p>Überprüfen Sie gegebenenfalls auch Ihren Spam-Ordner!</p>
  <form (keyup.enter)="resetPassword()" tabindex="0" [formGroup]="resetPasswordForm">
    <mat-form-field style="width: 40%" appearance="outline">
      <mat-label>E-Mail</mat-label>
      <input email="true" formControlName="email" matInput placeholder="" required type="email" autocomplete="username">
    </mat-form-field>
  </form>
</mat-dialog-content>
<div mat-dialog-actions class="mat-dialog-buttons">
  <button (click)="close()" mat-button mat-raised-button>Abbrechen</button>
  <button (click)="resetPassword()" color="primary" mat-raised-button>Passwort zurücksetzen</button>
</div>
